<template>
  <v-container grid-list-xl fluid >
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat tile class="elevation-0 mx-5 offset-holder">
          <div class="pa-10">
            <app-list slot="list"></app-list> 
          </div>
        </v-card>
      </v-flex>
    <app-detail></app-detail>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import AppList from './PageComponents/Application/List';
import AppDetail from './PageComponents/Application/Detail';

export default {
  components: {
    AppList,  
    AppDetail,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      selectedLocationObj: 'location/selected',
    }),
  },
  mounted() {
    this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_completed');
    this.spinner(false);
  },
  methods: {
    
    addModal() {
      this.setAdd(true);
    },

    ...mapActions({
      setAdd: 'application/setAdd',
      spinner: 'spinner/spinnerStatus',
    }),

  }
};
</script>
<style scoped>

</style>
